document.addEventListener('DOMContentLoaded', () => {
  const cmBtn = document.getElementById('cmBtn');
  const inBtn = document.getElementById('inBtn');
  const cmTable = document.getElementById('cmTable');
  const inTable = document.getElementById('inTable');

  if (cmBtn && inBtn && cmTable && inTable) {
    cmBtn.addEventListener('click', () => {
      cmTable.style.display = 'table';
      inTable.style.display = 'none';
      cmBtn.classList.add('active-btn');
      inBtn.classList.remove('active-btn');
    });

    inBtn.addEventListener('click', () => {
      cmTable.style.display = 'none';
      inTable.style.display = 'table';
      inBtn.classList.add('active-btn');
      cmBtn.classList.remove('active-btn');
    });
  }
});

window.addEventListener('load',function(){if(window.innerWidth>768){const sourceElement=document.querySelector('carousel-slider');const targetElement=document.querySelector('.media-gallery .carousel .slider__grid');function updateHeight(){if(sourceElement&&targetElement){const heightValue=sourceElement.style.getPropertyValue('--current-slide-height').trim();if(heightValue){targetElement.style.height=heightValue}}}
updateHeight();if('ResizeObserver' in window){const resizeObserver=new ResizeObserver(()=>{updateHeight()});resizeObserver.observe(sourceElement)}
window.addEventListener('resize',updateHeight)}})